module.exports = __webpack_public_path__ + "static/media/video.07b4f433.svg";